import { MD5, enc, mode, pad, AES } from 'crypto-js';
import { TCryptoJS } from '../basis/types/tcrypto-js';

const stringToHex = (str: string) => {
  let val = '';

  for (let i = 0; i < str.length; i++) {
    const charNum = str.charCodeAt(i).toString(16);

    val += charNum.length < 2 ? `0${charNum}` : charNum;
  }

  return val;
};

const hexToString = (str: string) => {
  let val = '';

  for (let i = 0; i < str.length; i += 2) {
    val += String.fromCharCode(parseInt(str.substr(i, 2), 16));
  }

  return val;
};

/**
 * 加密
 * @param options
 * @param options.str
 * @param options.key
 * @param options.iv
 * @returns 加密数据
 */
export const encrypt = (options: { str: string; key: string; iv: TCryptoJS.Iv }) => {
  const md5Key = MD5(MD5(options.key).toString()).toString();
  const key = enc.Hex.parse(md5Key);
  const iv = enc.Utf8.parse(options.iv);
  const str: any = AES.encrypt(options.str, key, { iv, mode: mode.CBC, padding: pad.Pkcs7 });

  return stringToHex(atob(str));
};

/**
 * 解密
 * @param options
 * @param options.str
 * @param options.key
 * @param options.iv
 * @returns 解密结果
 */
export const decrypt = (options: { str: string; key: string; iv: TCryptoJS.Iv }) => {
  const md5Key = MD5(MD5(options.key).toString()).toString();
  const key = enc.Hex.parse(md5Key);
  const iv = enc.Utf8.parse(options.iv);
  const src = btoa(hexToString(options.str));
  const decrypts = AES.decrypt(src, key, { iv, mode: mode.CBC, padding: pad.Pkcs7 });
  const decryptedStr = decrypts.toString(enc.Utf8);

  return decryptedStr.toString();
};
